import { useSelector } from 'react-redux';
import { type AppState } from '~/store/app.store';
import {
  type BoundaryGroupId, type BoundaryTerritoryGroupId,
} from '~/store/boundaries/boundaryIdentifier.type';

export const activeBTGIdPerBoundaryGroupSelector = (state: AppState): Record<BoundaryGroupId, BoundaryTerritoryGroupId> => {
  return state.map.mapSettings.data.toolsState.boundary.activeBTGIdPerBoundaryGroup;
};

export const useActiveBTGIdPerBoundaryGroupSelector = () => useSelector(activeBTGIdPerBoundaryGroupSelector);

export const useActiveBTGIdPerBoundaryGroup = (boundaryGroupId: BoundaryGroupId) => {
  return useSelector(activeBTGIdPerBoundaryGroupSelector)[boundaryGroupId] ?? null;
};
